import {
	REMIX_INTERACTION_SOURCES,
	SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE,
} from '@atlassian/conversation-assistant-instrumentation/constants/analytics';
import type { InteractionSource } from '@atlassian/conversation-assistant-instrumentation/constants/analytics';

export const getInvokedFromInteractionSource = (
	interactionSource: InteractionSource | undefined,
): string | undefined => {
	if (interactionSource !== undefined && REMIX_INTERACTION_SOURCES.has(interactionSource)) {
		return 'remix';
	}
	if (interactionSource === SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE) {
		return SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE;
	}
	return undefined;
};
